import { render, staticRenderFns } from "./addbatch.vue?vue&type=template&id=b3852fc2&scoped=true&"
import script from "./addbatch.vue?vue&type=script&lang=js&"
export * from "./addbatch.vue?vue&type=script&lang=js&"
import style0 from "./addbatch.vue?vue&type=style&index=0&id=b3852fc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3852fc2",
  null
  
)

export default component.exports